import { render, staticRenderFns } from "./SummaryTitle.vue?vue&type=template&id=44cbb9bb&scoped=true"
import script from "./SummaryTitle.vue?vue&type=script&lang=js"
export * from "./SummaryTitle.vue?vue&type=script&lang=js"
import style0 from "./SummaryTitle.vue?vue&type=style&index=0&id=44cbb9bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cbb9bb",
  null
  
)

export default component.exports